<template>
    <div class="components-forms">
        <div class="forms-body">
            <van-form @failed="onFailed" scroll-to-error @submit="onSubmit">
                <van-cell-group inset>
                    <van-field
                        v-model="personalForm.name"
                        name="name"
                        required
                        label="姓名"
                        placeholder="请输入您的姓名"
                        maxlength="20"
                        type="text"
                        show-word-limit
                        :rules="[{required: true, message: '请输入您的姓名'}]"
                    />
                    <van-field name="logo" required label="照片" :rules="[{required: true, message: '请上传个人照片'}]">
                        <template #input>
                            <van-uploader
                                v-model="personalForm.logo"
                                :max-count="1"
                                accept="image/*"
                                :after-read="personalLogoUpload"
                            />
                        </template>
                    </van-field>
                    <van-field
                        v-model="personalForm.company"
                        name="company"
                        label="公司名称"
                        placeholder="请输入公司名称"
                        maxlength="20"
                        type="text"
                        show-word-limit
                    />
                    <van-field
                        v-model="personalForm.title"
                        name="title"
                        label="职务"
                        placeholder="请输入您的职务"
                        maxlength="20"
                        type="text"
                        show-word-limit
                    />
                    <van-field
                        v-model="personalForm.phone"
                        name="phone"
                        required
                        label="手机号"
                        placeholder="请输入手机号"
                        :rules="[{ validator:checkPhone, message:checkMessage }]"
                    />
                    <van-field
                        v-model="personalForm.email"
                        name="email"
                        required
                        label="邮箱"
                        placeholder="请输入邮箱"
                        :rules="[{ validator:checkEmail, message:checkMessage }]"
                    />
                    <van-field name="topicTitle" v-model="personalForm.topicTitle" required label="想听议题" :rules="[{required: true, message: '请输入或选择您想听到的议题'}]">
                        <template #input>
                            <el-select
                                v-model="personalForm.topicTitle"
                                placeholder="请输入或选择您想听到的议题"
                                filterable
                                remote
                                :remote-method="handleRemote"
                                :reserve-keyword="true"
                                @blur="handleBlur"
                                @focus="handleFocus"
                                :default-first-option="false"
                            >
                                <el-option
                                    v-for="item in AreaList"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </template>
                    </van-field>
                    <van-field name="isChecked" label="" :rules="[{ validator:checkRules, message:checkMessage}]">
                        <template #input>
                            <van-checkbox v-model="personalForm.isChecked" icon-size="16px" shape="square">
                                <span><span style="color: #ee0a24;">*</span>阅读并同意
                                    <a style="color: #409eff;" href="https://cdn.isc.360.com/isc-cxo/ISC.AI%C2%A02025%C2%A0%E8%AE%AE%E9%A2%98%E5%BE%81%E9%9B%86%E6%8F%90%E4%BA%A4%E8%AF%B4%E6%98%8E.pdf"  target="_blank">《议题征集协议》</a>
                                    <a style="color: #409eff;" href="https://cdn.isc.360.com/isc-cxo/ISC.AI_2025_topic_rule.pdf"  target="_blank">《活动规则》</a>
                                </span>
                            </van-checkbox>
                        </template>
                    </van-field>
                </van-cell-group>
                <div style="margin: 20px 50px 0;">
                    <van-button round block type="primary" native-type="submit">
                    提交
                    </van-button>
                </div>
            </van-form>
        </div>
        <dialogVue ref="dialogRef" :data="posterInfo"></dialogVue>
    </div>
</template>
  
<script setup>
import { ref, onMounted, reactive } from 'vue';
import dialogVue from './myDialog.vue';
import { submitForm,uploadImg } from '@/api/2025';
import { ElLoading } from 'element-plus';
import { showFailToast } from 'vant';
import piexif from 'piexifjs';
import { topicList } from '@/mock/2026/topic.js';

let dialogRef = ref(null)

let posterInfo = ref({}) //海报列表

onMounted(() => {
    AreaList.value = topicList.map((item) => {
        return item.topic
    })
})

let AreaList = ref([]) //议题列表

const personalForm = reactive({
    name: '',
    logo: [],
    company: '',
    title: '',
    phone: '',
    email: '',
    topicTitle: '',
    isChecked: false,
    Orientation: 1
})
const checkPhone = (value) => {
    if (!value) {
        return '请填写手机号'
    }
    if (!(/^1[3456789]\d{9}$/.test(value))) {
        return '手机号格式有误，请检查'
    }
}
const checkEmail = (value) => {
    if (!value) {
        return '请填写邮箱';
    }
    if (!(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value))) {
        return '邮箱格式有误，请检查';
    }
}
const checkRules = (value) => {
    if (value==false) {
        return '请阅读并同意协议和规则';
    }
}
const checkMessage = (val) => `${val}`;

const personalLogoUpload = (uploader) => {
  const file = uploader.file
  // 只处理 JPEG
  if (!file.type.includes('jpeg') && !file.type.includes('jpg')) {
    console.warn('不是 JPEG 图片，跳过 EXIF 分析')
    // 继续上传
    uploadImg(file).then(res => {
    if (res.data.msg === "SUCCESS") {
        file.url = res.data.data.imageurl
        personalForm.logo = [file]
    } else {
        showFailToast(res.data.msg)
        personalForm.logo = []
    }
    })
    return false
  }

  const reader = new FileReader()
  reader.onload = function (e) {
    const dataUrl = e.target.result

    try {
      const exifObj = piexif.load(dataUrl)
      const orientation = exifObj["0th"][piexif.ImageIFD.Orientation]
    //   console.log('EXIF Orientation:', orientation)
      personalForm.Orientation = orientation
      // 可在此处添加基于 orientation 的图像旋转处理逻辑

      // 然后调用上传逻辑
      uploadImg(file).then(res => {
        if (res.data.msg === "SUCCESS") {
          file.url = res.data.data.imageurl
          personalForm.logo = [file]
        } else {
          showFailToast(res.data.msg)
          personalForm.logo = []
        }
      })

    } catch (error) {
      console.error('读取 EXIF 出错', error)
      // 继续上传
      uploadImg(file).then(res => {
        if (res.data.msg === "SUCCESS") {
          file.url = res.data.data.imageurl
          personalForm.logo = [file]
        } else {
          showFailToast(res.data.msg)
          personalForm.logo = []
        }
      })
    }
  }

  reader.readAsDataURL(file)

  return false
}

const loadingInstance = ref(null)
const openLoading = () => {
    loadingInstance.value = ElLoading.service({
        lock: true,
        text: '正在生成您的专属海报，请稍候...',
        svg: `
            <path class="path" d="
            M 30 15
            L 28 17
            M 25.61 25.61
            A 15 15, 0, 0, 1, 15 30
            A 15 15, 0, 1, 1, 27.99 7.5
            L 15 15
            " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
        `,
        svgViewBox: "-10, -10, 50, 50",
        background: 'rgba(0, 0, 0, 0.8)',
        customClass: 'my-loading',
    })
}
const closeLoading = () => {
    loadingInstance.value.close()
}

//个人想听
let customizeTopicTitle = ref('')
const handleRemote = (query) => {
    customizeTopicTitle.value = query
  // 不筛选，options保持不变
}
const handleFocus = () => {
    customizeTopicTitle.value = ''
    personalForm.topicTitle = ''
}
const handleBlur = () => {
  // 失焦的时候，如果没有选择联想项，保存输入内容
  if (!AreaList.value.find(item => item === personalForm.topicTitle)) {
    personalForm.topicTitle = customizeTopicTitle.value
  }
}

const onFailed = (errorInfo) => {
    console.log('failed', errorInfo);
};
const onSubmit = (values) => {
    console.log('submit', values);
    let newData = JSON.parse(JSON.stringify(personalForm))
    newData.logo = newData.logo[0].url
    newData.submissionMode = 'listen'
    newData.identityType = 'personal'
    newData.form_id = 1
    openLoading()
    return submitForm(newData).then(res => {
        if (res.data.msg == "SUCCESS") {
            posterInfo.value = {
                title: newData.topicTitle,
                avatar: newData.logo,
                name: newData.name,
            }
            setTimeout(() => {
                dialogRef.value.openModel()
                closeLoading()
            },1000)
        }else{
            closeLoading()
            showFailToast(res.data.msg)
        }
    })
};


</script>

<style lang="scss" scoped>
.components-forms {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin-bottom: 40px;
  .forms-body{
        width: 100%;
        padding: 20px 0;
        background: #fafafa;
        border-radius: 14px;
        border: 1px solid rgb(230, 226, 226);
        box-shadow: 0 8px 12px #ebedf0;
        :deep(.van-field__label){
            margin-right: 0px;
        }
    }
}
</style>